// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// eslint-disable-next-line @typescript-eslint/no-require-imports
require("@rails/ujs").start();
// eslint-disable-next-line @typescript-eslint/no-require-imports
require("@rails/activestorage").start();

import "semantic-ui-css/semantic.min.css";
import "react-datepicker/dist/react-datepicker.css";

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context("../images", true);
// const imagePath = name => images(name, true);

require.context("../images", true);

import { ja } from "date-fns/locale/ja";
import { registerLocale } from "react-datepicker";
registerLocale("ja", ja);
